import "./styles.css";
import { App } from "./ui/app";

const root = document.querySelector<HTMLElement>("#app");
if (!root) throw new Error("#app missing from index.html");

const app = new App();
root.replaceWith(app.element);
void app.boot();
